import { defineMessages, type MessageDescriptor } from 'react-intl';

import { USER_ACCOUNT_TYPES } from '@didaskill/domain/users/constants';
import type { Nullable } from '@didaskill/types/misc';
import { MOODS } from '@didaskill/ui/design-system';

export default defineMessages({
  SAY_MORE: {
    defaultMessage: 'Voulez-vous nous en dire plus ?',
  },

  THANKS_FEEDBACK: {
    defaultMessage: 'Merci pour vos retours !',
  },

  NEGATIVE_FEEDBACK_SUBTITLE: {
    defaultMessage: '🤝 N’hésitez pas à en parler à votre coach.',
  },

  SCHEDULE_APPOINTMENT: {
    defaultMessage: 'Prendre rendez-vous',
  },
} as const);

type MoodKey = null | MOODS;

export const titleMessages: Partial<
  Record<USER_ACCOUNT_TYPES, Record<Nullable<MOODS>, MessageDescriptor>>
> = {
  [USER_ACCOUNT_TYPES.STUDENT]: defineMessages<MoodKey, MessageDescriptor>({
    [null as string]: {
      defaultMessage: 'Comment se passe votre alternance ?',
    },
    [MOODS.POSITIVE]: {
      defaultMessage: 'Nous sommes heureux de l’apprendre !',
    },
    [MOODS.NEUTRAL]: {
      defaultMessage: 'Tout n’est pas parfait en ce moment...',
    },
    [MOODS.NEGATIVE]: {
      defaultMessage: 'Nous sommes désolés de voir que ça ne va pas.',
    },
  }),

  [USER_ACCOUNT_TYPES.TUTOR]: defineMessages<MoodKey>({
    [null as string]: {
      defaultMessage: "Comment se passe l'alternance avec {fullName}{nbsp}?",
    },
    [MOODS.POSITIVE]: {
      defaultMessage: 'Nous sommes heureux de l’apprendre{nbsp}!',
    },
    [MOODS.NEUTRAL]: {
      defaultMessage: 'Tout n’est pas parfait en ce moment...',
    },
    [MOODS.NEGATIVE]: {
      defaultMessage: 'Nous sommes désolés de voir que ça ne va pas.',
    },
  }),
};

export const sayMorePlaceholderMessages = defineMessages<MOODS>({
  [MOODS.POSITIVE]: {
    defaultMessage: 'Je suis prêt à déplacer des montagnes !',
  },

  [MOODS.NEUTRAL]: {
    defaultMessage: 'Il y a du bon… mais aussi quelques difficultés',
  },

  [MOODS.NEGATIVE]: {
    defaultMessage: 'Il y a du bon… mais aussi quelques difficultés',
  },
} as const);
